<script>
	import { createEventDispatcher } from "svelte";

	export let disabled = false;

	const dispatcher = createEventDispatcher();

	const deleteItem = () => {
		dispatcher("delete");
	};

	let className = $$props.class ? " " + $$props.class : "";
</script>

<button on:click|preventDefault={deleteItem} {disabled} aria-label="Delete" title="Delete" type="submit">
	<i class="fa fa-trash"></i>
</button>

<style>
	button {
		position: relative;
		color: var(--color-primary);
		background-color: transparent;
		border: none;
		padding: 0;
		padding-left: 30px;
		font-family: "Proxima Nova";
		font-size: 24px;
		font-weight: 600;
	}
</style>
